import { PageHeaderBlackText } from '@elements/Common';
import { NestedTable } from './NestedTable';

export function NestedField(props) {
  const {
    addNestedField,
    item,
    onChange,
    readOnly,
    removeNestedField,
    values,
  } = props;
  const commonProps = {
    ...props,
    rows: values,
    removeNestedField: index => removeNestedField(item.name, index),
    onChange: value => onChange(item.name, value),
    onPressEnter: () => addNestedField(item),
    fields: item.nestedFields,
    readOnly,
  };

  return (
    <>
      <div className="sk:w-full sk:flex-none sk:px-4 sk:flex! sk:items-center! sk:justify-between!">
        {item.label && (
          <PageHeaderBlackText className="sk:mt-3.5! sk:mb-1!">
            {item.label}
          </PageHeaderBlackText>
        )}
      </div>
      <div className="sk:w-full sk:flex-none sk:px-4 sk:mb-3.5!">
        <NestedTable
          {...commonProps}
          allowActions={!readOnly && item.multiple}
        />
      </div>
    </>
  );
}
